import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { OKTA_AUTH } from '@okta/okta-angular';
import { environment } from '../../../environments/environment';

export const oktaAuthInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  const oktaAuth = inject(OKTA_AUTH);
  const accessToken = oktaAuth.getAccessToken();
  if (!accessToken) {
    return next(req);
  }

  const authReq = req.clone({ setHeaders: { Authorization: `Bearer ${accessToken}` } });
  return next(authReq);
};
